<template>
  <div class="archivio-container">
    <h1>Gestione Invii di Giornata / Archivio</h1>

    <!-- Selezione intervallo date -->
    <div class="date-filters">
      <label for="startDate">Data Inizio</label>
      <input
        type="date"
        v-model="startDate"
        id="startDate"
      />

      <label for="endDate">Data Fine</label>
      <input
        type="date"
        v-model="endDate"
        id="endDate"
      />
    </div>

    <!-- Pulsanti di ricerca -->
    <div class="search-buttons">
      <button @click="searchMainCollection" :disabled="isLoading">
        Cerca documenti (principale)
      </button>
      <button @click="searchArchiveCollection" :disabled="isLoading">
        Cerca documenti (archivio)
      </button>
    </div>

    <!-- Contatore documenti trovati -->
    <p v-if="!isLoading && foundDocuments.length > 0">
      Documenti trovati: <strong>{{ foundDocuments.length }}</strong>
    </p>

    <!-- Loading Spinner -->
    <div v-if="isLoading" class="loader">
      <p>Caricamento in corso...</p>
    </div>

    <!-- Tabella risultati -->
    <div v-if="foundDocuments.length > 0 && !isLoading">
      <h2>
        Stato attuale: {{ isArchiveView ? 'Archivio' : 'Principale' }}
      </h2>

      <!-- Pulsanti azione su TUTTI i documenti -->
      <div class="bulk-actions">
        <button v-if="!isArchiveView" @click="archiveAllDocs" class="bulk-button">
          Archivia e Cancella Tutti
        </button>
        <button v-else @click="restoreAllDocs" class="bulk-button">
          Ripristina Tutti
        </button>
      </div>

      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Data Creazione</th>
            <th>Email / Nome / Cognome</th>
            <th>Azione Singola</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="doc in foundDocuments" :key="doc.id">
            <td>{{ doc.id }}</td>
            <td>{{ formatDate(doc.createdAt) }}</td>
            <td>{{ doc.email }} / {{ doc.name }} / {{ doc.surname }}</td>
            <td>
              <!-- Azione singola -->
              <button v-if="!isArchiveView" @click="archiveDoc(doc)">
                Archivia e Cancella
              </button>
              <button v-else @click="restoreDoc(doc)">
                Ripristina
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Nessun risultato -->
    <div v-else-if="!isLoading && foundDocuments.length === 0">
      <p>Nessun documento trovato per l'intervallo selezionato.</p>
    </div>
  </div>
</template>

<script>
import {
  getFirestore,
  collection,
  doc,
  getDocs,
  setDoc,
  deleteDoc,
  query,
  where
} from "firebase/firestore";

export default {
  name: "InviiComponent_archivio",
  data() {
    return {
      startDate: "",
      endDate: "",
      foundDocuments: [],
      isLoading: false,
      isArchiveView: false // true se sto guardando l'archivio, false se la collezione principale
    };
  },
  methods: {
    async searchMainCollection() {
      if (!this.startDate || !this.endDate) {
        alert("Seleziona entrambe le date per favore.");
        return;
      }
      this.isArchiveView = false;
      this.foundDocuments = [];
      this.isLoading = true;

      try {
        const db = getFirestore();
        const start = new Date(this.startDate);
        const end = new Date(this.endDate);

        const colRef = collection(db, "inviidigiornata");
        const qMain = query(
          colRef,
          where("createdAt", ">=", start),
          where("createdAt", "<=", end)
        );

        const snapshot = await getDocs(qMain);
        snapshot.forEach((docSnap) => {
          if (docSnap.exists()) {
            this.foundDocuments.push({
              id: docSnap.id,
              ...docSnap.data()
            });
          }
        });
      } catch (error) {
        console.error("Errore durante la ricerca nella collezione principale:", error);
        alert("Errore durante la ricerca. Controlla la console per i dettagli.");
      } finally {
        this.isLoading = false;
      }
    },

    async searchArchiveCollection() {
      if (!this.startDate || !this.endDate) {
        alert("Seleziona entrambe le date per favore.");
        return;
      }
      this.isArchiveView = true;
      this.foundDocuments = [];
      this.isLoading = true;

      try {
        const db = getFirestore();
        const start = new Date(this.startDate);
        const end = new Date(this.endDate);

        const colRef = collection(db, "inviidigiornata_archivio");
        const qArchive = query(
          colRef,
          where("createdAt", ">=", start),
          where("createdAt", "<=", end)
        );

        const snapshot = await getDocs(qArchive);
        snapshot.forEach((docSnap) => {
          if (docSnap.exists()) {
            this.foundDocuments.push({
              id: docSnap.id,
              ...docSnap.data()
            });
          }
        });
      } catch (error) {
        console.error("Errore durante la ricerca nell'archivio:", error);
        alert("Errore durante la ricerca. Controlla la console per i dettagli.");
      } finally {
        this.isLoading = false;
      }
    },

    async archiveDoc(docData) {
      const conferma = confirm(`Archivia e cancella il documento ${docData.id}?`);
      if (!conferma) return;

      try {
        this.isLoading = true;
        const db = getFirestore();

        await setDoc(doc(db, "inviidigiornata_archivio", docData.id), {
          ...docData
        });
        await deleteDoc(doc(db, "inviidigiornata", docData.id));

        this.foundDocuments = this.foundDocuments.filter(d => d.id !== docData.id);
        alert(`Documento ${docData.id} archiviato con successo!`);
      } catch (error) {
        console.error("Errore durante l'archiviazione:", error);
        alert("Errore durante l'archiviazione. Controlla la console per i dettagli.");
      } finally {
        this.isLoading = false;
      }
    },

    async restoreDoc(docData) {
      const conferma = confirm(`Ripristinare il documento ${docData.id}?`);
      if (!conferma) return;

      try {
        this.isLoading = true;
        const db = getFirestore();

        await setDoc(doc(db, "inviidigiornata", docData.id), {
          ...docData
        });
        await deleteDoc(doc(db, "inviidigiornata_archivio", docData.id));

        this.foundDocuments = this.foundDocuments.filter(d => d.id !== docData.id);
        alert(`Documento ${docData.id} ripristinato con successo!`);
      } catch (error) {
        console.error("Errore durante il ripristino:", error);
        alert("Errore durante il ripristino. Controlla la console per i dettagli.");
      } finally {
        this.isLoading = false;
      }
    },

    async archiveAllDocs() {
      if (this.foundDocuments.length === 0) {
        alert("Nessun documento da archiviare.");
        return;
      }
      const conferma = confirm("Archivia e cancella TUTTI i documenti trovati?");
      if (!conferma) return;

      try {
        this.isLoading = true;
        const db = getFirestore();

        for (const docData of this.foundDocuments) {
          await setDoc(doc(db, "inviidigiornata_archivio", docData.id), {
            ...docData
          });
          await deleteDoc(doc(db, "inviidigiornata", docData.id));
        }

        alert("Tutti i documenti sono stati archiviati con successo!");
        this.foundDocuments = [];
      } catch (error) {
        console.error("Errore durante l'archiviazione di tutti:", error);
        alert("Errore durante l'archiviazione. Controlla la console per i dettagli.");
      } finally {
        this.isLoading = false;
      }
    },

    async restoreAllDocs() {
      if (this.foundDocuments.length === 0) {
        alert("Nessun documento da ripristinare.");
        return;
      }
      const conferma = confirm("Ripristinare TUTTI i documenti trovati?");
      if (!conferma) return;

      try {
        this.isLoading = true;
        const db = getFirestore();

        for (const docData of this.foundDocuments) {
          await setDoc(doc(db, "inviidigiornata", docData.id), {
            ...docData
          });
          await deleteDoc(doc(db, "inviidigiornata_archivio", docData.id));
        }

        alert("Tutti i documenti sono stati ripristinati con successo!");
        this.foundDocuments = [];
      } catch (error) {
        console.error("Errore durante il ripristino di tutti:", error);
        alert("Errore durante il ripristino. Controlla la console per i dettagli.");
      } finally {
        this.isLoading = false;
      }
    },

    formatDate(dateValue) {
      if (!dateValue) return "N/D";
      const dateObj = dateValue.toDate ? dateValue.toDate() : new Date(dateValue);
      return dateObj.toLocaleDateString("it-IT", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
      });
    }
  }
};
</script>

<style scoped>
.archivio-container {
  margin: 20px;
}

.date-filters {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 20px;
}

.search-buttons {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

/* Contatore semplice */
p {
  font-size: 16px;
}

.loader {
  margin: 20px 0;
  font-weight: bold;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

table th,
table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

table th {
  background-color: #f1f1f1;
}

.bulk-actions {
  margin: 10px 0;
}

.bulk-button {
  padding: 8px 16px;
  margin-right: 10px;
  background-color: #f44336; /* Rosso */
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.bulk-button:hover {
  background-color: #d32f2f;
}
</style>
